import de from './de.json';
import en from './en.json';
import hu from './hu.json';

/**
 * Message catalogues by language. Bundled eagerly: the shell's vocabulary is a
 * few hundred bytes per language, and a locale switch must not flash untranslated
 * chrome while a chunk loads. Plant and Learn CONTENT is a separate, per-locale
 * fetch — that is the payload worth splitting, not this.
 */
const CATALOGUES = { de, en, hu };

export function getCatalogue(languageCode) {
    return CATALOGUES[languageCode] || CATALOGUES.en;
}

/**
 * Look a message up. A missing key returns the key itself rather than throwing or
 * rendering blank — a visible `nav.plants` in the UI is a bug report; an empty
 * element is a silent hole.
 */
export function translate(languageCode, messageKey) {
    const catalogue = getCatalogue(languageCode);

    return Object.prototype.hasOwnProperty.call(catalogue, messageKey)
        ? catalogue[messageKey]
        : messageKey;
}

/**
 * Fill a message's `{placeholders}` from an object.
 *
 * Catalogue copy carries placeholders because word order is not ours to choose —
 * "About {plant}" is "{plant} bemutatása" in Hungarian, so the name cannot be
 * concatenated on at the call site.
 */
export function interpolate(message, values = {}) {
    return Object.entries(values).reduce(
        (filled, [name, value]) => filled.split(`{${name}}`).join(String(value)),
        String(message),
    );
}

export { CATALOGUES };
